import { render } from "./Forgotpw.vue?vue&type=template&id=66e21c3a&scoped=true"
import script from "./Forgotpw.vue?vue&type=script&lang=js"
export * from "./Forgotpw.vue?vue&type=script&lang=js"

import "./Forgotpw.vue?vue&type=style&index=0&id=66e21c3a&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\cazino\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66e21c3a"]])

export default __exports__